import { Item, ItemGroup, QrCode } from '@/models'
import { isFood } from '@/utils'

const baseApiUrl = process.env.VUE_APP_BASE_URL_API

const baseKioskUrl = process.env.VUE_APP_BASE_URL_KIOSK

const baseKioskStoreUrl = process.env.VUE_APP_BASE_URL_KIOSK_STORE

/**
 * Returns the brand image URL.
 *
 * It adds a timestamp in the URL to avoid cache problems.
 *
 * @param providerId Provider that owns the brand.
 */
export function brandUrl (providerId: number) {
  const stamp = Date.now()

  return `${baseApiUrl}/menu/accounts/${providerId}/images/brand?time=${stamp}`
}

/**
 * Returns the image URL for an Item or ItemGroup, or null.
 *
 * @param object Item or ItemGroup whose image URL will be returned.
 */
export function imageUrl (object: Item | ItemGroup) {
  if (object.imageId === null) {
    return null
  }

  return `${baseApiUrl}/menu/images/${object.imageId}.jpg`
}

/**
 * Returns the sign-in URL for a QrCode.
 *
 * @param qrCode QrCode whose URL will be returned.
 */
export function qrCodeUrl (qrCode: QrCode) {
  return `${isFood() ? baseKioskUrl : baseKioskStoreUrl}/sign-in/${qrCode.code}`
}
